export default function PrivacyPolicy() {
  return (
    <div className="flex flex-col items-center font-sans px-4">
      <h1 className="text-[#5C2D91] text-center font-bold max-w-[90%]">Política de Privacidade</h1>
      <p><strong>Última atualização:</strong> 14 de maio de 2025</p>

      <p>
        A sua privacidade é muito importante para nós. Esta Política de Privacidade descreve como coletamos, usamos,
        armazenamos e protegemos suas informações ao utilizar o site <a href="https://visageai.sofiq.com.br" target="_blank" rel="noopener noreferrer">visageai.sofiq.com.br</a>.
      </p>

      <h2>1. Informações que Coletamos</h2>
      <p>Coletamos informações para fornecer e melhorar nossos serviços. Isso pode incluir:</p>
      <ul>
        <li><strong>Informações pessoais:</strong> nome, telefone, e-mail ou outras informações fornecidas voluntariamente.</li>
        <li><strong>Informações de navegação:</strong> endereço IP, navegador, páginas visitadas, cookies e localização aproximada.</li>
      </ul>

      <h2>2. Uso das Informações</h2>
      <p>As informações coletadas são utilizadas para:</p>
      <ul>
        <li>Prestar os serviços oferecidos pela plataforma VisageAI;</li>
        <li>Entrar em contato com você quando necessário;</li>
        <li>Enviar comunicações e atualizações, com seu consentimento;</li>
        <li>Analisar dados de uso e melhorar nossos serviços.</li>
      </ul>

      <h2>3. Compartilhamento de Informações</h2>
      <p>Seus dados não são vendidos nem compartilhados com terceiros, exceto:</p>
      <ul>
        <li>Quando exigido por lei ou autoridade competente;</li>
        <li>Com parceiros operacionais que respeitem esta política.</li>
      </ul>

      <h2>4. Uso de Cookies</h2>
      <p>Utilizamos cookies para melhorar a navegação e funcionalidades do site. Você pode desativá-los no seu navegador.</p>

      <h2>5. Segurança das Informações</h2>
      <p>Adotamos medidas técnicas e administrativas para proteger seus dados contra acessos não autorizados ou usos indevidos.</p>

      <h2>6. Direitos do Usuário</h2>
      <p>Você pode a qualquer momento:</p>
      <ul>
        <li>Acessar os dados que coletamos sobre você;</li>
        <li>Solicitar correção, atualização ou exclusão de seus dados;</li>
        <li>Retirar o consentimento para uso dos dados.</li>
      </ul>
      <p>Para isso, envie um e-mail para <a href="mailto:alessandro.silveira@sofiq.com.br">alessandro.silveira@sofiq.com.br</a>.</p>

      <h2>7. Alterações nesta Política</h2>
      <p>Esta política pode ser atualizada periodicamente. A versão mais recente estará sempre disponível nesta página.</p>

      <h2>8. Contato</h2>
      <p>Em caso de dúvidas sobre esta Política de Privacidade, entre em contato:</p>
      <ul>
        <li><strong>E-mail:</strong> <a href="mailto:alessandro.silveira@sofiq.com.br">alessandro.silveira@sofiq.com.br</a></li>
        <li><strong>Site:</strong> <a href="https://visageai.sofiq.com.br" target="_blank" rel="noopener noreferrer">visageai.sofiq.com.br</a></li>
      </ul>
    </div>
  );
}
